// Stage 1 "Silent defaults" · group G4 (Code Health Report V1: A-10, A-14, A-2, A-34, A-35, A-15) — sign-off, verification
// and EQ texts, EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_SD_G4 = {
  en: {
    errors: {
      // A-10: no engagement partner recorded → the Partner level / report release is refused (was: any Partner)
      SIGNOFF_NO_ENGAGEMENT_PARTNER: "Appoint the engagement partner in Team first.",
      // A-15: no presentation framework → sign-off / Partner stage / PDF refused (the mapping gate cannot run)
      PREFLIGHT_FRAMEWORK_NOT_SET: "Cannot proceed: this engagement has no presentation framework (IAS 1 or IFRS 18), so the FS mapping check cannot run. Set the framework in Engagement settings, map the accounts, then sign off or export.",
    },
    isqmPage: {
      // A-34: an ISQM export verified by its stamp only (file bytes not checked) is PARTIAL, not PASS
      verifyPartial: "Partially verified — stamp matches, file bytes not checked",
      toastVerifyPartial: "Partially verified — the file bytes could not be checked",
    },
    sdg4: {
      bv: {
        // A-2: a signed bundle the firm holds no record of is never PASS
        notOnRecordTitle: "NOT ON RECORD — no record of this bundle",
        notOnRecordBlurb: "This firm holds no record of a signed bundle for this engagement, so the bundle cannot be verified. A matching manifest inside the archive proves only that the archive agrees with itself.",
      },
      preflight: {
        // A-15: the sign-off card banner when the framework is missing
        noFrameworkTitle: "Presentation framework not set — sign-off and export are blocked",
      },
    },
  },
  ar: {
    errors: {
      SIGNOFF_NO_ENGAGEMENT_PARTNER: "عيّن شريك المهمة في صفحة الفريق أولاً.",
      PREFLIGHT_FRAMEWORK_NOT_SET: "لا يمكن المتابعة: لا يوجد إطار عرض (IAS 1 أو IFRS 18) لهذه المهمة، فلا يمكن تشغيل فحص ربط القوائم المالية. حدّد الإطار في إعدادات المهمة، ثم اربط الحسابات، ثم وقّع أو صدّر.",
    },
    isqmPage: {
      verifyPartial: "تحقق جزئي — الختم مطابق، لم تُفحص بايتات الملف",
      toastVerifyPartial: "تحقق جزئي — لم يمكن فحص بايتات الملف",
    },
    sdg4: {
      bv: {
        notOnRecordTitle: "غير مسجّل — لا يوجد سجل لهذه الحزمة",
        notOnRecordBlurb: "لا يوجد لدى هذا المكتب سجل لحزمة موقَّعة لهذه المهمة، فلا يمكن التحقق من الحزمة. تطابق البيان داخل الأرشيف يثبت فقط أن الأرشيف متوافق مع نفسه.",
      },
      preflight: {
        noFrameworkTitle: "إطار العرض غير محدد — التوقيع والتصدير محجوبان",
      },
    },
  },
};

export default I18N_SD_G4;
